"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GatewayTimeoutError = exports.BadGatewayError = exports.InternalServerError = exports.NotFoundError = exports.MfaFactorNotAllowedError = exports.InvalidOtpError = exports.InvalidTokenError = exports.InvalidParameterError = exports.GenericError = void 0;
const core_1 = require("@smash-sdk/core");
class GenericError extends core_1.SDKError {
}
exports.GenericError = GenericError;
class InvalidParameterError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InvalidParameterError";
    }
}
exports.InvalidParameterError = InvalidParameterError;
class InvalidTokenError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InvalidTokenError";
    }
}
exports.InvalidTokenError = InvalidTokenError;
class InvalidOtpError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InvalidOtpError";
    }
}
exports.InvalidOtpError = InvalidOtpError;
class MfaFactorNotAllowedError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "MfaFactorNotAllowedError";
    }
}
exports.MfaFactorNotAllowedError = MfaFactorNotAllowedError;
class NotFoundError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "NotFoundError";
    }
}
exports.NotFoundError = NotFoundError;
class InternalServerError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InternalServerError";
    }
}
exports.InternalServerError = InternalServerError;
class BadGatewayError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "BadGatewayError";
    }
}
exports.BadGatewayError = BadGatewayError;
class GatewayTimeoutError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "GatewayTimeoutError";
    }
}
exports.GatewayTimeoutError = GatewayTimeoutError;
exports.default = {
    GenericError,
    InvalidParameterError,
    InvalidTokenError,
    InvalidOtpError,
    MfaFactorNotAllowedError,
    NotFoundError,
    InternalServerError,
    BadGatewayError,
    GatewayTimeoutError,
};
